import sGravityControlHtml from './sGravityControl.html';

/**
* @class sGravityControlController
* @memberof module:"7Shop.Core"
*/
/* @ngInject */
function sGravityControlController(
  $scope,
  $filter,
  $timeout,
  KeyMapper,
  ScanSvc,
  DatepickerService
) {
  const ctrl = this;
  let currentDateRangeFormName = ''; // if we have more date-ranges we need to know which one is selected to change its values
  ctrl.dropdownMethods = [];
  ctrl.datepickerConfig = {
    isOpen: false,
    startView: 'day',
    minView: 'day',
    showWeeks: false,
    maxMode: 'day',
    customClass: function (dateObject) {
      return DatepickerService
        .isDateInRange(dateObject.date, ctrl.formViewModel?.[currentDateRangeFormName]?.dateRange) ? 'selected' : '';
    }
  };

  ctrl.$onInit = function () {
    generateMethods();
    initializeDropdownFormModels();

    if (ctrl.field.control === 'date-range') {
      $scope.$on(
        '7S:Datepicker.DateSelected',
        ctrl.onDateSelect
      );
    }
  };

  // Watch for changes in dropdown data to keep form model synchronized
  ctrl.$onChanges = function (changes) {
    if (changes.dropdownData && ctrl.dropdownData) {
      // Re-initialize when dropdown data changes
      initializeDropdownFormModels();
    }
  };

  ctrl.onMultiSelectItemSelected = (fieldFormName) => {
    // Get selected items from multiselect data
    const selectedItems = ctrl.multiSelectData[fieldFormName]
      .filter((item) => item.selected === true)
      .map((item) => item.value);

    // Update form view model
    ctrl.formViewModel[fieldFormName] = selectedItems;

    // Update form validation state
    $timeout(() => {
      if (ctrl.form?.[ctrl.field.name]) {
        ctrl.form[ctrl.field.name].$setViewValue(selectedItems.length > 0 ? selectedItems : null);
        ctrl.form[ctrl.field.name].$validate();
      }
    }, 0);
  };

  function initializeDropdownFormModels() {
    if (ctrl.dropdownData && ctrl.field.control === 'dropdown') {
      const { formName } = ctrl.field;
      const dropdownConfig = ctrl.dropdownData[formName];

      if (dropdownConfig?.selectedValue?.value) {
        // Ensure form model is synchronized with dropdown selected value
        ctrl.formViewModel[formName] = dropdownConfig.selectedValue.value;

        // Update form validation state if form field exists
        $timeout(() => {
          if (ctrl.form && ctrl.form[ctrl.field.name]) {
            ctrl.form[ctrl.field.name].$setViewValue(dropdownConfig.selectedValue.value);
            ctrl.form[ctrl.field.name].$validate();
          }
        }, 0);
      }
    }
  }

  ctrl.onDateSelect = function () {
    if (currentDateRangeFormName) {
      ctrl.formViewModel[currentDateRangeFormName].dateRange = DatepickerService.getSelectedDateRange(
        ctrl.formViewModel[currentDateRangeFormName].currentDate,
        ctrl.formViewModel[currentDateRangeFormName].dateRange,
        ctrl.formViewModel[currentDateRangeFormName].dateRangeInit
      );
      ctrl.formViewModel[currentDateRangeFormName].dateRangeInit = false; // needed because of some strange date picker logic
      ctrl.formViewModel[currentDateRangeFormName].currentDate = ctrl.formViewModel[currentDateRangeFormName].dateRange.start;
      $scope.$applyAsync();
    }
  };

  /**
   * @param {string} fieldFormName
   * @param {Event} e
   */
  ctrl.handleInputScan = (fieldFormName, e) => {
    if (ScanSvc.shouldPropagateScanKey(e.key)) {
      return;
    }

    e.stopPropagation();
    const code = ctrl.formViewModel[fieldFormName];
    if (!code || e.key !== KeyMapper.enter.text) {
      return;
    }

    ctrl.onScanFinished({ code });
    ctrl.formViewModel[fieldFormName] = '';
    e.preventDefault();
  };

  ctrl.toggleDatePicker = (formName) => {
    currentDateRangeFormName = formName;
    ctrl.formViewModel[formName].isOpen = !ctrl.formViewModel[formName].isOpen;
  };

  function generateMethods() {
    var keyNames;
    if (ctrl.dropdownData) {
      keyNames = Object.keys(ctrl.dropdownData);
      if (keyNames) {
        keyNames.forEach((element) => {
          const fieldName = ctrl.field.name;
          ctrl['dropdownSelect' + element] = function (data) {
            // Update dropdown data
            ctrl.dropdownData[element].selectedValue = $filter('filter')(
              ctrl.dropdownData[element].selectData,
              { value: data },
              true
            )[0];

            // Update form model for validation
            ctrl.formViewModel[element] = data;

            // Trigger form validation update
            if (ctrl.form?.[fieldName]) {
              ctrl.form[fieldName].$setViewValue(data);
              ctrl.form[fieldName].$validate();
            }
          };
        });
      }
    }
  }
}

export default {
  templateUrl: sGravityControlHtml,
  controller: sGravityControlController,
  bindings: {
    field: '<',
    formViewModel: '<',
    dropdownData: '<',
    multiSelectData: '<',
    form: '<',
    touch: '<',
    onScanFinished: '&'
  }
};
